import { useCallback } from "react";
import { useSetRecoilState } from "recoil";
import { trialBlockModalState } from "@/recoil/atom";

/**
 * 체험용 계정 마이페이지 접근 제한 모달을 띄우는 훅.
 *
 * 현재 정책: 로그인한 모든 계정을 체험용으로 간주한다.
 * 마이페이지 진입(헤더 메뉴)·학습통계·AI 진단·내가 푼 문제 클릭 시
 * 페이지 이동 대신 본 훅이 반환하는 함수를 호출해 제한 모달을 띄운다.
 * 리포트(/my?view=report)만 메인 화면의 전용 경로로 직접 접근할 수 있다.
 */
export function useTrialBlock() {
  const setName = useSetRecoilState(trialBlockModalState);
  return useCallback((name: string) => setName(name), [setName]);
}
